import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { FormioForm } from 'src/components/FormioForm/FormioForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { Router } from 'src/core/router/Router';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { CombinedLoadingStatus } from 'src/utils/mobx/CombinedLoadingStatus';

export type EntityCreateProps = {
    store: BasicStore<any>;
    entityListUrl: string;
};
export const EntityCreate = observer(
    ({ store, entityListUrl }: EntityCreateProps) => {
        const entityUrl = entityListUrl;

        useEffect(() => {
            store.loadForm(store.itemCreateFormKey);
            store.createItemLoader.reset();

            return () => {
                store.formLoader.reset();
            };
        }, []);
        const loadingStatus = useMemo(() => {
            return new CombinedLoadingStatus([store.formLoader]);
        }, []);

        if (loadingStatus.isLoading) {
            return <SpinnerFullWidth />;
        }

        return (
            <FormioForm
                key="create"
                form={store.currentItemForm as any}
                submission={{ data: {} } as any}
                onSubmit={async (submission) => {
                    const newItem = await store.create?.(submission.data);

                    if (newItem) {
                        store.loadList();
                        Router.navigate(`${entityListUrl}/${newItem.id}`);
                    }
                }}
                onCustomEvent={async (event) => {
                    if (event.type === 'save') {
                        const newItem = await store.create?.(event.data);
                        if (newItem) {
                            store.loadList();
                            Router.navigate(`${entityListUrl}/${newItem.id}`);
                        }
                    } else if (event.type === 'cancel') {
                        Router.navigate(entityUrl);
                    }
                }}
            />
        );
    },
);
